import { NextPage } from 'next';
import { v2_FallbackProvider as FallbackProvider } from '@crocodille/common';

export type AppPage<
  // eslint-disable-next-line @typescript-eslint/ban-types
  P = {},
  IP = P,
> = NextPage<P, IP> & {
  getLayout?: (page: React.ReactElement, pageProps: P) => React.ReactNode;
};

export function isPageWithLayout<
  // eslint-disable-next-line @typescript-eslint/ban-types
  IP = {},
  // eslint-disable-next-line @typescript-eslint/ban-types
  P = {},
>(
  PageComponent: NextPage<IP, P>,
): PageComponent is NextPage<IP, P> &
  Required<Pick<AppPage<IP, P>, 'getLayout'>> {
  return 'getLayout' in PageComponent;
}

export function pageWithSWRFallback<
  // eslint-disable-next-line @typescript-eslint/ban-types
  P = {},
  IP = P,
>(
  PageComponent: AppPage<P, IP>,
): AppPage<P & { readonly fallback: Record<string, unknown> }, IP> {
  const PageWithFallback: AppPage<
    P & { readonly fallback: Record<string, unknown> },
    IP
  > = (props) => {
    return (
      <FallbackProvider fallback={props.fallback}>
        <PageComponent {...props} />
      </FallbackProvider>
    );
  };

  PageWithFallback.getInitialProps = PageComponent.getInitialProps;
  PageWithFallback.getLayout = PageComponent.getLayout;

  return PageWithFallback;
}
